<template>
    <div style="width:80%;margin :0 auto">
        <h2>Produits achetés</h2><br />
        <multiselect
            v-model="values"  
            :options="options" 
            placeholder="Liste des produits"                                          
            :searchable="true"
             :multiple="true"
             @change="setArticles"
            :show-labels="false">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    props: {
        chartDatas: { type: Object, required: false, default: function () { return {}}},
    },
    watch: {
         
    chartDatas : {
        deep: true,
        handler(newValue) {            
            this.options = newValue.graph_articles_id

        }
    },
    values : {
        handler(newValue) {    
            console.log(newValue)
        }
    }
    },         
    components: {
        Multiselect,
    },
    methods:  {
      setArticles(value) {
        console.log(value)
      }
    },
    data () {
      return {
        values: [],
        options: []
    }
    }  
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>